import { faqTypes } from './faq.types';

// FAQ
export const fetchFAQListStart = ({ channelId, page, pageSize }) => ({
  type: faqTypes.FETCH_FAQ_LIST_START,
  payload: { channelId, page, pageSize },
});

export const fetchMoreFAQList = (payload) => ({
  type: 'FETCH_MORE_FAQ_LIST',
  payload,
});

export const setFAQList = (faqList) => ({
  type: faqTypes.SET_FAQ_LIST,
  payload: faqList,
});

export const setPageAndPageSize = (pageData) => ({
  type: faqTypes.SET_PAGE_AND_PAGESIZE_DATA,
  payload: pageData,
});

export const updateFAQEnableStart = (faqId, isEnabled) => ({
  type: faqTypes.UPDATE_FAQ_ENABLE_START,
  payload: { faqId, isEnabled },
});

export const getSingleFAQStart = (faqId) => ({
  type: faqTypes.FETCH_SINGLE_FAQ_START,
  payload: faqId,
});

export const addNewFAQStart = (
  faqData,
  setIsSubmittingFAQForm,
  history,
  prevUrl
) => ({
  type: faqTypes.ADD_NEW_FAQ_START,
  payload: { faqData, setIsSubmittingFAQForm, history, prevUrl },
});

export const updateFAQStart = (faqData, setIsSubmittingFAQForm) => ({
  type: faqTypes.UPDATE_FAQ_START,
  payload: { faqData, setIsSubmittingFAQForm },
});

export const setUpdatedFAQ = (faqId, updatedFields) => ({
  type: faqTypes.SET_UPDATED_FAQ,
  payload: { faqId, updatedFields },
});

export const deleteFAQById = (faqId) => ({
  type: faqTypes.DELETE_FAQ,
  payload: { faqId },
});

export const setOnEditFAQ = (faqData) => ({
  type: faqTypes.SET_ON_EDIT_FAQ,
  payload: faqData,
});

export const restartOnEditFAQ = () => ({
  type: faqTypes.RESTART_ON_EDIT_FAQ,
});

// Questions
export const fetchQuestionsStart = (faqId) => ({
  type: faqTypes.FETCH_QUESTION_START,
  payload: faqId,
});

export const addNewQuestionStart = (questionData, setIsSubmittingForm) => ({
  type: faqTypes.ADD_NEW_QUESTION_START,
  payload: { questionData, setIsSubmittingForm },
});

export const sortQuestionsStart = ({
  newQuestionsByUpdatedOrders,
  faqId,
  oldQuestions,
}) => ({
  type: faqTypes.SORT_QUESTIONS_START,
  payload: { newQuestionsByUpdatedOrders, faqId, oldQuestions },
});

export const updateQuestionStart = (data, setIsSubmittingForm) => ({
  type: faqTypes.UPDATE_QUESTION_START,
  payload: { data, setIsSubmittingForm },
});

export const deleteQuestionStart = ({
  questionId,
  faqId,
  tempId,
  setLoadingDelete,
  setConfirmModalVisible,
}) => ({
  type: faqTypes.DELETE_QUESTION_START,
  payload: {
    questionId,
    faqId,
    tempId,
    setLoadingDelete,
    setConfirmModalVisible,
  },
});

export const deleteFAQStart = ({
  faqId,
  setLoadingDelete
}) => ({
  type: faqTypes.DELETE_FAQ_START,
  payload: {
    faqId,
    setLoadingDelete,
  },
});

export const createEmptyQuestion = () => ({
  type: faqTypes.CREATE_EMPTY_QUESTION,
});

export const setOnEditQuestion = (tempId, data) => ({
  type: faqTypes.SET_ON_EDIT_QUESTION,
  payload: { tempId, data },
});

export const setQuestionsList = (questions) => ({
  type: faqTypes.SET_QUESTIONS_LIST,
  payload: questions,
});

export const setQuestionData = (data) => ({
  type: faqTypes.SET_QUESTION_DATA,
  payload: data,
});

export const toggleQuestionExpand = (tempId) => ({
  type: faqTypes.TOGGLE_QUESTION_EXPAND,
  payload: tempId,
});
